export const formatDuration = (durationMs?: number): string => {
  if (durationMs == null) return '运行中';
  if (durationMs < 1000) return `${durationMs} ms`;
  return `${(durationMs / 1000).toFixed(durationMs >= 10_000 ? 1 : 2)} s`;
};

export const formatNumber = (value?: number): string =>
  value == null ? '—' : new Intl.NumberFormat('zh-CN').format(value);

export const formatTime = (value: string): string =>
  new Intl.DateTimeFormat('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(new Date(value));

export const sourceLabel = (source: string): string => {
  const labels: Record<string, string> = {
    'ai-backend': 'AI Backend',
    'game-server': 'Game Server',
    'unity-client': 'Unity Client',
  };
  return labels[source] ?? source;
};

export const statusLabel = (status: string): string => {
  const labels: Record<string, string> = {
    success: '成功',
    running: '运行中',
    error: '异常',
    healthy: '健康',
    degraded: '降级',
    unavailable: '不可用',
    cancelled: '已取消',
  };
  return labels[status] ?? status;
};

export const prettyJson = (value: unknown): string => JSON.stringify(value, null, 2);
